export type EntityScopeKind = 'fundraiser' | 'team' | 'collection';

export const CONTENT_MODERATION_ROUTES = {
  queue: '/content-moderation',
  detail: (id: number | string) => `/content-moderation/event/${id}`,
  detailPattern: '/content-moderation/event/:id',
  // Entity-scoped history view: the entity id is the only query param, so the
  // queue renders the full moderation history for that fundraiser/team/collection.
  entityHistory: (kind: EntityScopeKind, id: number | string) =>
    `/content-moderation?${kind}Id=${id}`,
} as const;

export const KEYBOARD_SHORTCUTS = {
  approve: 'a',
  block: 'b',
  skip: 's',
  confirm: 'Enter',
} as const;

export const I18N_BASE = 'contentModeration';
